import { useState, useRef, useCallback } from "react";

const useVideoPlayer = () => {
    const videoRefs = useRef({});
    const [mutedMap, setMutedMap] = useState({});
    const [playingMap, setPlayingMap] = useState({});

    const toggleMute = useCallback((id) => {
        setMutedMap((prev) => {
            const newMuted = !prev[id];
            const video = videoRefs.current[id];
            if (video) video.muted = newMuted;
            return { ...prev, [id]: newMuted };
        });
    }, []);

    const togglePlayPause = useCallback((id) => {
        const video = videoRefs.current[id];
        if (!video) return;

        if (video.paused) {
            video.play();
            setPlayingMap((prev) => ({ ...prev, [id]: true }));
        } else {
            video.pause();
            setPlayingMap((prev) => ({ ...prev, [id]: false }));
        }
    }, []);

    const registerVideoRef = useCallback((id, ref) => {
        if (!ref) return;
        videoRefs.current[id] = ref;

        setMutedMap((prev) => (id in prev ? prev : { ...prev, [id]: true }));
        setPlayingMap((prev) => (id in prev ? prev : { ...prev, [id]: true }));
    }, []);

    return {
        videoRefs,
        mutedMap,
        playingMap,
        toggleMute,
        togglePlayPause,
        registerVideoRef,
        setPlayingMap,
        setMutedMap,
    };
};

export default useVideoPlayer;